import * as React from "react";
const SvgJumpIcon = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 20.275c-1.95 0-3.604-.68-4.963-2.038C1.68 16.88 1 15.225 1 13.275c0-2.05.73-3.72 2.188-5.013C4.646 6.971 6.274 6.383 8.075 6.5l-2.15-2.15L7 3.275l4 4-4 4L5.925 10.2 8.15 7.975c-1.583-.033-2.92.45-4.013 1.45-1.091 1-1.637 2.283-1.637 3.85 0 1.517.538 2.812 1.612 3.887C5.188 18.237 6.483 18.775 8 18.775h3v1.5H8Zm5-9v-7h9v7h-9Zm0 9v-7h9v7h-9Zm1.5-1.5h6v-4h-6v4Z"
      fill="#fff"
    />
  </svg>
);
export default SvgJumpIcon;
